export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1617761141732-d481912af1a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBidWlsZGluZyUyMGZhY2FkZXxlbnwwfHx8fDE3ODc3MjA3MzJ8MA&ixlib=rb-4.1.0&q=85",
  services: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1260&h=900&q=80",
  team: "https://images.pexels.com/photos/4308104/pexels-photo-4308104.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  blueprints: "https://images.unsplash.com/photo-1603901622056-0a5bee231395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3R1cmFsJTIwYmx1ZXByaW50cyUyMG9uJTIwZGVza3xlbnwwfHx8fDE3ODc3MjA3MzJ8MA&ixlib=rb-4.1.0&q=85",
};

export const CONTACT = {
  address: "Ground Floor, Plot No. 9, Samta Nagar, Vaishali Marg West, Jaipur, Rajasthan — 302034",
  email: "manish@auricvaluation.com",
  altEmails: ["rajasthan@auricvaluation.com", "rajasthan1@auricvaluation.com"],
  phone: "+91 90791 94425",
  altPhones: ["+91 97733 47163", "+91 97733 47164"],
  website: "www.auricvaluation.com",
};

export const STATS = [
  { value: "35,000+", label: "Valuation assignments completed successfully" },
  { value: "45+", label: "Institutions served — banks, NBFCs & corporates" },
  { value: "50+", label: "Qualified & experienced professionals" },
  { value: "12+", label: "Years of deep domain expertise" },
  { value: "35+", label: "Key locations across Rajasthan & beyond" },
  { value: "100%", label: "Integrity — unbiased, confidential, independent" },
];

export const PROCESS_STRIP = [
  { title: "Inspection", desc: "On-ground property inspection" },
  { title: "Market Study", desc: "In-depth market research & analysis" },
  { title: "Valuation", desc: "Technical valuation using standard methodologies" },
  { title: "Value Opinion", desc: "Clear value opinion with transparent rationale" },
];

export const WHY_AURIC = [
  "Single-point coordination through an experienced valuation manager.",
  "Qualified technical review with practical site inspection capability.",
  "Reports aligned with local market practice and financial institution policy.",
  "Clear assumptions, property observations and value rationale in reporting.",
  "Service built on transparency, accuracy and professional ethics.",
  "Timely turnaround with accuracy, transparency and reliability.",
];

export const SERVICES = [
  { title: "Property Valuation", desc: "Residential, commercial, industrial, land and special purpose properties." },
  { title: "Plant & Machinery Valuation", desc: "Valuation of plant, machinery, equipment and technical assets." },
  { title: "Loan Secured Valuation", desc: "Valuation for loan proposals, renewals, top-ups and credit facilities." },
  { title: "Project & Feasibility Studies", desc: "Detailed project reports, feasibility analysis and financial viability studies." },
  { title: "Business Valuation", desc: "Valuation of companies, shares, goodwill, brand and intangible assets." },
  { title: "Merger & Acquisition Support", desc: "Valuation advisory for M&A, joint ventures, restructuring and due diligence." },
  { title: "Tax & Litigation Support", desc: "Valuation for tax matters, disputes, compliance and legal proceedings." },
  { title: "Intangible Asset Valuation", desc: "Valuation of intellectual property, patents, trademarks, licenses and brand equity." },
  { title: "Financial Instrument Valuation", desc: "Valuation of equity shares, preference shares, debentures and derivatives." },
  { title: "Insurance Valuation", desc: "Asset valuation for insurance purposes including claim assessment support." },
  { title: "RBI & Statutory Valuations", desc: "Valuations as per RBI guidelines and other statutory requirements." },
  { title: "Other Advisory Services", desc: "Customized advisory solutions tailored to client-specific requirements." },
];

export const APPROACH_STEPS = [
  { num: "01", title: "Understand", desc: "We understand the purpose, scope and specific requirements of the engagement." },
  { num: "02", title: "Research", desc: "In-depth market research backed by reliable data and industry insights." },
  { num: "03", title: "Analyze", desc: "Robust analysis using appropriate valuation methodologies and best practices." },
  { num: "04", title: "Evaluate", desc: "Derive fair and accurate value conclusion with clear rationale." },
  { num: "05", title: "Deliver", desc: "Timely delivery of transparent, well-documented and reliable reports." },
];

export const DIFFERENTIATORS = [
  { title: "Experienced Professionals", desc: "A team of qualified and experienced valuers with diverse expertise across asset classes." },
  { title: "Independent & Objective", desc: "Unbiased, impartial and independent valuation reports you can rely on." },
  { title: "Quality & Compliance", desc: "Strict adherence to regulatory standards, best practices and ethical guidelines." },
  { title: "Domain Expertise", desc: "Deep understanding of industries, markets and valuation methodologies." },
  { title: "Timely Delivery", desc: "Commitment to delivering high-quality reports within agreed timelines." },
  { title: "Client-Centric Approach", desc: "Customized solutions tailored to meet our clients' unique requirements — delivered with professionalism and integrity." },
];

export const ASSET_CLASSES = [
  { title: "Real Estate", desc: "Residential, commercial, industrial, land and special purpose properties." },
  { title: "Plant & Machinery", desc: "Industrial plants, machinery, equipment, utilities and technical assets." },
  { title: "Financial Assets", desc: "Shares, debentures, preference shares, derivatives and other securities." },
  { title: "Intangible Assets", desc: "Brand, goodwill, patents, trademarks, licences, IPR and other intangibles." },
  { title: "Loan & Credit Facilities", desc: "Secured and unsecured loans, project finance and structured credit facilities." },
  { title: "Insurance & Claims", desc: "Asset valuation for insurance, claim settlement and loss assessment." },
];

export const INDUSTRIES = [
  "Real Estate & Construction",
  "Manufacturing & Engineering",
  "Retail & Consumer",
  "Power & Energy",
  "Banking, NBFCs & Financial Services",
  "Healthcare & Education",
  "IT & Business Services",
];

export const LOCATIONS = [
  "Ajmer", "Alwar", "Baran", "Beawar", "Bharatpur", "Bhilwara", "Bhiwadi", "Bundi",
  "Chittorgarh", "Churu", "Dausa", "Deeg", "Didwana-Kuchaman", "Dudu", "Gangapur City",
  "Jaipur", "Jhalawar", "Jhunjhunu", "Jodhpur", "Karauli", "Kekri", "Khairthal-Tijara",
  "Khetri", "Kota", "Kotputli-Behror", "Nagaur", "Neem Ka Thana", "Pali", "Rajsamand",
  "Sawai Madhopur", "Shahpura", "Sikar", "Tonk", "Udaipur",
];

export const CLIENTS = [
  { name: "Cholamandalam Investment & Finance", logo: "/images/clients/chola.png" },
  { name: "Piramal Finance", logo: "/images/clients/piramal.png" },
  { name: "Motilal Oswal Home Finance", logo: "/images/clients/motilaloswal.png" },
  { name: "SMFG India Home Finance", logo: "/images/clients/smfghf.png" },
  { name: "Ujjivan Small Finance Bank", logo: "/images/clients/ujjivan.png" },
  { name: "CSL Finance", logo: "/images/clients/csl.png" },
  { name: "Unity Small Finance Bank", logo: "/images/clients/unity.png" },
  { name: "SMC Finance", logo: "/images/clients/smc.png" },
  { name: "Svatantra Micro Housing Finance", logo: "/images/clients/svatantra.png" },
  { name: "UGRO Capital", logo: "/images/clients/ugro.png" },
  { name: "PNB Housing Finance", logo: "/images/clients/pnbhousing.png" },
  { name: "IndusInd Bank", logo: "/images/clients/indusind.png" },
  { name: "Muthoot FinCorp", logo: "/images/clients/muthoot.png" },
  { name: "Roha Housing Finance", logo: "/images/clients/roha.png" },
  { name: "SMFG India Credit", logo: "/images/clients/smfgcredit.png" },
  { name: "Ummeed Housing Finance", logo: "/images/clients/ummeed.png" },
  { name: "Adani Housing Finance", logo: "/images/clients/adani.png" },
  { name: "Paisabuddy", logo: "/images/clients/paisabuddy.png" },
  { name: "KIFS Housing Finance", logo: "/images/clients/kifs.png" },
  { name: "MS Fincap", logo: "/images/clients/msfc.png" },
  { name: "Ambit Finvest", logo: "/images/clients/ambit.png" },
  { name: "Shriram Housing Finance", logo: "/images/clients/shriram.png" },
  { name: "Truhome Finance", logo: "/images/clients/truhome.png" },
  { name: "Clix Capital", logo: "/images/clients/clx.png" },
  { name: "JM Financial", logo: "/images/clients/jmfinancial.png" },
  { name: "Western Capital", logo: "/images/clients/prabhaav.png" },
  { name: "Vistaar Finance", logo: "/images/clients/vistaar.png" },
  { name: "Tyger Capital", logo: "/images/clients/tygercapital.png" },
  { name: "Tyger Home Finance", logo: "/images/clients/tygerhome.png" },
  { name: "Criss Financial", logo: "/images/clients/criss.png" },
  { name: "Prest Loans", logo: "/images/clients/prest.png" },
  { name: "EZ Capital", logo: "/images/clients/ezcapital.png" },
  { name: "Fusion Finance", logo: "/images/clients/fusion.png" },
  { name: "Mitrata Inclusive Financial Services", logo: "/images/clients/mitrata.png" },
  { name: "Vasud Finance", logo: "/images/clients/vasud.png" },
  { name: "Pyramid Finserve", logo: "/images/clients/pyramid.png" },
  { name: "Ritwik Finance", logo: "/images/clients/twik.png" },
  { name: "Rikalp Capital", logo: "/images/clients/rikalp.png" },
  { name: "Pinkline Finance Company", logo: "/images/clients/pinkline.png" },
  { name: "Choice Finserve", logo: "/images/clients/choice.png" },
  { name: "Mintifi Finserve", logo: "/images/clients/mintifi.png" },
  { name: "Vagmi Capital Services", logo: "/images/clients/vagmi.png" },
  { name: "Saswat Finance", logo: "/images/clients/saswat.png" },
];

export const CERTIFICATIONS = [
  { title: "IBBI", desc: "Insolvency and Bankruptcy Board of India — Registered Valuer", logo: "/images/certs/ibbi.png" },
  { title: "IOV", desc: "Institution of Valuers — ISO 9001:2015 | ISO 26000:2010", logo: "/images/certs/iov.png" },
  { title: "NISM", desc: "National Institute of Securities Markets — a SEBI capacity building initiative", logo: "/images/certs/nism.png" },
  { title: "Chartered Engineer", desc: "The Institution of Engineers (India) — Chartered Engineer certification", logo: "/images/certs/iei.png" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/approach", label: "Approach" },
  { to: "/clients", label: "Empanelments" },
  { to: "/founder", label: "Founder" },
  { to: "/contact", label: "Contact" },
];
